import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Home } from 'components/Home';
import { useSelector } from 'react-redux';
import { getIsAuth } from 'redux/reducers/auth/selectors';
import { LoginPage } from 'pages/LoginPage';
import { LastMail } from 'components/LastMail';

export const LastMailPage: FC = () => {
	const ifAuth = useSelector(getIsAuth);

	return ifAuth ? (
		<Page title="Home">
			<LastMail />
		</Page>
	) : (
		<LoginPage />
	);
};
